import { ReactNode } from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { Text, tokens } from '@fhs/ui';

interface Props {
  children: ReactNode;
  circular?: boolean;
  color?: string;
  textColor?: string;
  style?: StyleProp<ViewStyle>;
}

export function Badge({
  children,
  circular = false,
  color = tokens.colors.$success,
  textColor = tokens.colors.$white,
  style,
}: Props) {
  const borderRadius = circular ? 30 : 4;
  const formatStyle = circular
    ? { borderRadius, height: 20, width: 20 }
    : { borderRadius, paddingHorizontal: 8, paddingVertical: 3.5 };
  return (
    <View style={[styles.badge, { backgroundColor: color }, formatStyle, style]}>
      <Text.Ui weight="semibold" size="sm" style={{ color: textColor }}>
        {children}
      </Text.Ui>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});
